export function getChartOptions(options) {
    return {
        chart: {
            type: 'gauge',
            plotBackgroundColor: 'none',
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        title: {
            text: ''
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                borderWidth: 0,
                outerRadius: '109%'
            }, {
                borderWidth: 0,
                outerRadius: '107%'
            }, {
                // default background
            },]
        },
        yAxis: {
            min: 0,
            max: options.data.horasSemPlPt > 200 ? options.data.horasSemPlPt : 200,

            minorTickInterval: 'auto',
            minorTickWidth: 1,
            minorTickLength: 10,
            minorTickPosition: 'inside',
            minorTickColor: '#6A6A6A',

            tickPixelInterval: 30,
            tickWidth: 2,
            tickPosition: 'inside',
            tickLength: 10,
            tickColor: '#6A6A6A',
            labels: {
                step: 2,
                rotation: 'auto'
            },
            title: {
                text: 'Horas'
            },
            plotBands: [{
                from: 0,
                to: options.data.horasUteisAtual,
                color: '#2D9B52' // green
            }, {
                from: options.data.horasUteisAtual,
                to: options.horasLiberadas.horasUteis,
                color: '#ffee58' // yellow
            }, {
                from: options.horasLiberadas.horasUteis,
                to: options.data.horasSemPlPt > 200 ? options.data.horasSemPlPt : 200,
                color: '#D92D20' // red
            }]
        },
        series: [{
            name: 'Horas Apontadas',
            data: [options.data.horasSemPlPt + options.data.horasFerias],
            tooltip: {
                valueSuffix: ' horas'
            }
        }]
    };
}
